/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["button[_ngcontent-%COMP%]{margin-left:10px}\n/*# sourceMappingURL=confirm-dialog.component.css.map*/"];
export { styles as styles };
